export const NAV = {
  root: 'navbar-root',
  logo: 'navbar-logo',
  linkHome: 'navbar-link-home',
  linkResidences: 'navbar-link-residences',
  linkPhilosophy: 'navbar-link-philosophy',
  linkLandscapes: 'navbar-link-landscapes',
  linkSustainability: 'navbar-link-sustainability',
  linkContact: 'navbar-link-contact',
  cta: 'navbar-cta-schedule',
  mobileToggle: 'navbar-mobile-toggle',
  mobileMenu: 'navbar-mobile-menu',
};

export const HERO = {
  root: 'hero-root',
  slide: (i) => `hero-slide-${i}`,
  prev: 'hero-slider-prev-button',
  next: 'hero-slider-next-button',
  dot: (i) => `hero-slider-dot-${i}`,
  ctaExplore: 'hero-cta-explore',
  ctaVisit: 'hero-cta-visit',
};

export const PHILOSOPHY = { root: 'philosophy-root' };

export const RESIDENCES = {
  root: 'residences-root',
  track: 'residences-track',
  card: (i) => `residence-card-${i}`,
  prev: 'residences-prev-button',
  next: 'residences-next-button',
};

export const SUSTAIN = {
  root: 'sustainability-root',
  item: (i) => `sustainability-item-${i}`,
};

export const LIFESTYLE = { root: 'lifestyle-root' };

export const TESTIMONIALS = {
  root: 'testimonials-root',
  prev: 'testimonials-prev',
  next: 'testimonials-next',
  slide: (i) => `testimonial-slide-${i}`,
};

export const ENQUIRY = {
  root: 'enquiry-root',
  nameInput: 'contact-form-name-input',
  emailInput: 'contact-form-email-input',
  phoneInput: 'contact-form-phone-input',
  interestSelect: 'contact-form-interest-select',
  messageInput: 'contact-form-message-input',
  submit: 'contact-form-submit-button',
};

export const FOOTER = { root: 'footer-root' };

export const PAGE_HERO = { root: 'page-hero-root' };

export const RESIDENCES_PAGE = {
  root: 'residences-page-root',
  filter: (region) => `residences-filter-${region.toLowerCase()}`,
  grid: 'residences-grid',
  gridCard: (slug) => `residence-grid-card-${slug}`,
  gridCardLink: (slug) => `residence-grid-card-link-${slug}`,
  empty: 'residences-empty-state',
};

export const RESIDENCE_DETAIL = {
  root: 'residence-detail-root',
  gallery: (i) => `residence-detail-gallery-${i}`,
  enquireCta: 'residence-detail-enquire',
  notFound: 'residence-not-found',
};

export const PHILOSOPHY_PAGE = {
  root: 'philosophy-page-root',
  principle: (i) => `philosophy-principle-${i}`,
  milestone: (i) => `philosophy-milestone-${i}`,
};

export const LANDSCAPES_PAGE = {
  root: 'landscapes-page-root',
  card: (slug) => `landscape-card-${slug}`,
};

export const SUSTAINABILITY_PAGE = {
  root: 'sustainability-page-root',
  promise: (i) => `sustainability-promise-${i}`,
};

export const CONTACT_PAGE = { root: 'contact-page-root' };
